import { useEffect, useRef } from "react";

export function usePreviousNonEmptyArray<T>(
  value: T[] | null | undefined,
): T[] | undefined {
  const ref = useRef<T[] | undefined>(undefined);

  useEffect(() => {
    if (value !== null && value !== undefined && value.length > 0) {
      ref.current = value;
    }
  }, [value]);

  return ref.current;
}
